module.exports = __webpack_public_path__ + "6ba03e211aa90296051372bceaf3ad24.MP3";